/**
 * Признак того, что клиент зовёт серверную функцию по идентификатору, которого в текущем
 * серверном бандле уже нет.
 *
 * <p>Идентификаторы server functions меняются при сборке. У человека с открытой вкладкой остаётся
 * старый клиентский бандл, и после деплоя каждый его вызов упирается в «Server function info not
 * found» — на проде 04.08.2026 так набралось 86 промахов за час после выкатки и ещё 26 пачкой у
 * одного пользователя спустя два с половиной часа. Лечится ровно тем же, чем протухшие чанки:
 * одной перезагрузкой страницы.
 */
const STALE_SERVER_FN_PATTERNS = ['server function info not found', 'server function not found'];

export const isStaleServerFnError = (error: unknown): boolean => {
  if (!error) {
    return false;
  }

  const message =
    typeof error === 'string'
      ? error
      : typeof (error as { message?: unknown }).message === 'string'
        ? (error as { message: string }).message
        : '';

  if (!message) {
    return false;
  }

  const normalized = message.toLowerCase();
  return STALE_SERVER_FN_PATTERNS.some((pattern) => normalized.includes(pattern));
};
